export default {
	"order.paymentSuccessful": "支付成功",
	"order.ParameterError": "參數錯誤",
	"order.YourPaymentResultHasNotBeenQueriedYet": "暫未查詢到您的支付結果",
	"order.lookUpAgain": "重新查詢",
	"order.payAgain": "重新支付",
	"order.RequestingPaymentResults": "請求支付結果中..."
}